import { LogLevels } from './types/LogLevels';

const styles = {
    Debug: 'background: #2980b9; color: #fff; padding: 2px 4px;',
    Info: 'background: #27ae60; color: #fff; padding: 2px 4px;',
    Warn: 'background: #e67e22; color: #fff; padding: 2px 4px;',
    Error: 'background: #c0392b; color: #fff; padding: 2px 4px;'
};

export function log(level: LogLevels, message: string) {
    console.log(`%c${level}`, styles[level], message);
}
